<template>
    <svg
        class="icon-chevron-right m-auto"
        :class="iconClasses"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
    >
        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
    </svg>
</template>

<script>
export default {
    name: 'IconChevronRight',
    props: {
        size: {
            required: false,
            type: Number,
            default: 6,
        },
    },
    computed: {
        iconClasses() {
            return `h-${this.size} w-${this.size}`;
        },
    },
};
</script>
